var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashPinMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-stroke",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 14.25c-.645 0-1.219.413-1.423 1.025l-2 6c-.153.458-.076.96.206 1.352.282.391.735.623 1.217.623h19.5c.482 0 .935-.232 1.217-.623.282-.391.359-.894.206-1.352l-2-6c-.204-.612-.778-1.025-1.423-1.025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.5c0 3.25-5.132 10.527-6.446 12.336-.07.097-.183.155-.303.155s-.233-.058-.304-.155C10.383 18.027 5.25 10.75 5.25 7.5 5.25 3.772 8.272.75 12 .75s6.75 3.022 6.75 6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.25H11.25c-.644-.002-1.199.454-1.32 1.087-.123.632.222 1.262.82 1.5l2.655.825c.598.239.941.869.82 1.5-.123.632-.676 1.089-1.32 1.088H9.75M12 5.25L12 3.75M12 12.75L12 11.25"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPinMap);
export default __webpack_public_path__ + "static/media/cash-pin-map.d29601d4.svg";
export { ForwardRef as ReactComponent };